export const CHAT_ROUTES = {
  HOME: '',
  HOME_CHAT: 'home',
  CHAT_CALL: 'chat-call',
  CHAT_MESSAGES: 'chat-messages'
};
